import { put, select } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import axios from 'src/api/Api';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

import {
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
    SET_PRODUCT_TEMPLATE_REFINE_DATA,
    SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
} from 'src/pages/more/pages/templates/redux/action/actionTypes.js';

export function* getTemplate(action) {
    const resourceType = 'ORDER_TEMPLATE_B';
    const params = convertObjectToQueryParams({
        ...action.payload,
        resourceType: resourceType,
    });
    const { isMastOrderTemplate } = yield select((state) => ({
        isMastOrderTemplate: state.commonTemplateReducer.isMastOrderTemplate,
    }));
    const { isMastOrder } = yield select((state) => ({
        isMastOrder: state.loginReducer.isMastOrder,
    }));
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templateslist?${params}&templateType=${
        isMastOrderTemplate || isMastOrder
            ? 'ZLC_MAST'
            : action.payload.typeList
            ? action.payload.typeList
            : 'ALL'
    }`;

    try {
        const result = yield axios.get(url).then((response) => response.data);
        yield put({
            type: GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
            payload: result.templateList || [],
            statusCode: result.statusCode,
            statusMessage: result.statusMessage,
            pagination: {
                pageNum: result.pageNo,
                pageLimit: result.pageSize,
            },
            totalNoOfResults: result.totalNoOfResults,
        });
        yield put({
            type: SET_PRODUCT_TEMPLATE_REFINE_DATA,
            payload: result.templateRefineData || {},
        });
        yield put({
            type: SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST,
            payload: result.templateSubCategoryList || [],
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
            statusCode: errorHandler('503'),
            statusMessage: e.Error,
        });
    }
}
